import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container container-vehicles d-flex flex-column align-items-center" }
const _hoisted_2 = { class: "pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RentComponent = _resolveComponent("RentComponent")!
  const _component_VehicleSelectWrapperComponent = _resolveComponent("VehicleSelectWrapperComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_RentComponent, {
      "with-driver": this.store.state.order.withDriver,
      onOnSearchSubmit: _ctx.onSearchSubmit
    }, null, 8, ["with-driver", "onOnSearchSubmit"]),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('choose-vehicle.select_a_vehicle')), 1),
    _createVNode(_component_VehicleSelectWrapperComponent, { ref: "vehicleSelectWrapperComponent" }, null, 512)
  ]))
}